import { Card, CardContent } from "@/components/ui/card";
import { Calculator, Clock, FileText, MessageSquare, Percent } from "lucide-react";

const painPoints = [
  { icon: Calculator, text: "Calculating student age during admission" },
  { icon: Clock, text: "Daily MDM calculation and reporting" },
  { icon: FileText, text: "Writing leave applications repeatedly" },
  { icon: MessageSquare, text: "Sending daily reports in WhatsApp groups" },
  { icon: Percent, text: "Calculating marks and percentages manually" },
];

export default function PainPointsSection() {
  return (
    <section data-testid="pain-points-section" className="py-12 md:py-20 bg-white">
      <div className="container mx-auto px-4 md:px-6 max-w-5xl">
        <h2
          data-testid="pain-points-headline"
          className="text-3xl md:text-4xl font-bold text-slate-900 text-center"
          style={{ fontFamily: "'Outfit', sans-serif" }}
        >
          Every Teacher Faces These <span className="text-green-700">Daily Problems</span>
        </h2>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {painPoints.map((item, i) => (
            <Card
              key={i}
              data-testid={`pain-point-card-${i}`}
              className="bg-white border border-red-100 hover:border-red-200 transition-colors shadow-sm"
            >
              <CardContent className="flex items-start gap-4 p-5">
                <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-red-50 flex items-center justify-center">
                  <item.icon className="w-5 h-5 text-red-500" />
                </div>
                <p className="text-sm md:text-base text-slate-700 leading-relaxed">{item.text}</p>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="mt-8 text-center">
          <p className="text-slate-500 text-sm">These tasks waste valuable teaching time.</p>
          <p className="mt-2 text-base md:text-lg font-semibold text-green-700">
            Teacher Utility Toolkit helps you complete these tasks in seconds instead of minutes.
          </p>
        </div>
      </div>
    </section>
  );
}
